import { useEffect } from 'react';

const DEFAULT_TITLE = 'Screenshot & OCR License Portal — HForgeX';
const DEFAULT_DESCRIPTION =
    'Activate Screenshot & OCR Pro, manage devices, and retrieve your license.';

export function usePortalPageMeta({ title, description = DEFAULT_DESCRIPTION }) {
    useEffect(() => {
        const previousTitle = document.title;
        const descriptionElement = document.querySelector('meta[name="description"]');
        const previousDescription = descriptionElement?.getAttribute('content') || '';

        document.title = title || DEFAULT_TITLE;
        if (descriptionElement && description) {
            descriptionElement.setAttribute('content', description);
        }

        return () => {
            document.title = previousTitle || DEFAULT_TITLE;
            if (descriptionElement && previousDescription) {
                descriptionElement.setAttribute('content', previousDescription);
            }
        };
    }, [description, title]);
}
